// Точка входа кастомного элемента региона и его изолированного Vue-приложения.
import { appLink } from '@experience/core-app-link-lib';
import { createI18n } from '@experience/i18n';
import { initWebComponent } from '@experience/vite-plugin-wc-extract-styles';
import { createHead } from '@unhead/vue/client';
import { createPinia } from 'pinia';
import { defineCustomElement } from 'vue';
import { createWebHistory, createRouter, createRouterMatcher } from 'vue-router';

import { MF_NAME } from '@/shared/config/env';
import { ruI18nPluralize } from '@/shared/lib/language';

import App from './App.ce.vue';
import { initPlugins } from './plugins';
import { mfRoutes } from './router';

const matcher = createRouterMatcher(mfRoutes, {});

export default initWebComponent({
  elementName: MF_NAME,
  stylesUrl: new URL(`${window.location.origin}/mfs/${MF_NAME}/extracted-styles.css`),
  dev: import.meta.env.DEV,

  defineElement: (styles) =>
    defineCustomElement(App, {
      styles,

      configureApp(app) {
        // Передаём host router matcher и сохраняем пустой API-префикс для ссылок MFE.
        app.use(appLink({ matcher, hostAppRouterName: '__HOST_APP_ROUTER__', redirectApiPrefix: '' }));
        app.use(createHead());
        app.use(createPinia());
        app.use(
          createI18n({
            legacy: false,
            locale: 'ru',
            fallbackLocale: 'ru',
            pluralRules: {
              ru: ruI18nPluralize,
            },
          }),
        );

        const router = createRouter({
          history: createWebHistory('/'),
          routes: mfRoutes,
        });

        app.use(router);

        // Подключаем QueryClient после создания router, чтобы запросы жили внутри MFE.
        initPlugins(app);
      },
    }),
});
